<template>
  <div>
    <Menu mode="horizontal" :active-name="$route.name" @on-select="selectMenu">
      <span style="float: left">
        <a style="margin-left: 24px; margin-right: 24px;" v-on:click="$router.push({ name: 'server' })">
        <Icon type="md-arrow-round-back" size="18" />
      </a>
      </span>
      <MenuItem name="private_cloud_server_detail">
        基本信息
      </MenuItem>
      <!--<MenuItem name="2">-->
        <!--监控-->
      <!--</MenuItem>-->
      <MenuItem name="private_cloud_server_console">
        控制台
      </MenuItem>
      <MenuItem name="private_cloud_server_console_log">
        控制台日志
      </MenuItem>
      <MenuItem name="private_cloud_server_operate_log">
        操作日志
      </MenuItem>
    </Menu>
    <Card shadow style="margin-top: 10px">
      <Row>
        <Form inline>
          <FormItem label="查看所有" :label-width="60">
            <i-switch v-model="all">
              <span slot="open"></span>
              <span slot="close"></span>
            </i-switch>
          </FormItem>
          <FormItem label="日志长度" :label-width="60" v-if="!all">
            <InputNumber :min="1" v-model="length" />
          </FormItem>
          <FormItem>
            <Button icon="md-refresh" @click="getConsoleLog"></Button>
          </FormItem>
        </Form>
      </Row>
      <Divider style="margin-top: 0"/>
      <spin fix v-if="dataGetting"></spin>
      <Alert show-icon type="error" v-else-if="error">获取数据失败</Alert>
      <pre v-else-if="output" style="white-space: pre-wrap; word-wrap: break-word;">{{ output }}</pre>
      <Alert v-else show-icon>暂无日志</Alert>
    </Card>
  </div>
</template>

<script>
import { actionPrivateCloudServer } from '@/api/private-cloud/server'

export default {
  name: 'server-console-log',
  data () {
    return {
      all: false,
      length: 30,
      error: false,
      dataGetting: false,
      output: ''
    }
  },
  created: function () {
    this.getConsoleLog()
  },
  methods: {
    selectMenu (name) {
      this.$router.push({name: name, params: { id: this.$route.params.id }})
    },
    getConsoleLog () {
      let reqData = {
        'os-getConsoleOutput': {}
      }
      if (!this.all) {
        reqData['os-getConsoleOutput'].length = this.length
      }
      this.dataGetting = true
      this.error = false
      actionPrivateCloudServer(reqData, this.$route.params.id).then(res => {
        this.output = res.data.output
        this.dataGetting = false
      }).catch(res => {
        this.dataGetting = false
        this.error = true
        this.$Notice.error({
          title: '获取控制台日志失败'
        })
        console.error(res.response)
      })
    }
  }
}
</script>

<style scoped>

</style>
